import {
  JbButton
} from "./chunk.IH5FQLMU.js";
import {
  jb_alert_css_default
} from "./chunk.BPZVZP4N.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-alert/jb-alert.ts
var JbAlert = class extends Initiable(r) {
  constructor() {
    super(...arguments);
    this.ARIALABEL_DEFAULT = {
      close: "Close"
    };
  }
  static create(data) {
    const buttons = data.buttons.map(
      (option) => new JbButton().init({
        props: option,
        attributes: { slot: "buttons" }
      })
    );
    return new JbAlert().init({
      props: data,
      childNodes: [...buttons]
    });
  }
  unstacked() {
    this.remove();
  }
  _close() {
    this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
  }
  render() {
    return ke`
      <div class="wrap">
        <div class="logo-wrap">
          <jb-logo
            isWhite
            .svgLogo=${this.svgLogo}
          ></jb-logo>
        </div>
        <div class="close-icon-wrap">
          <button
            @click=${this._close}
            aria-label=${this.ariaLabels?.close || this.ARIALABEL_DEFAULT.close}
          >
            <jb-close-icon></jb-close-icon>
          </button>
        </div>
        <h5>${this.title}</h5>
        <jb-richtext .size=${"small"}>${ae(this.content)}</jb-richtext>
        ${this.showLegend ? ke`<p class="legend">${this.legend}</p>` : D}
        <jb-button-panel .align=${"center"}><slot name="buttons"></slot></jb-button-panel>
      </div>
    `;
  }
};
JbAlert.styles = [reset_css_default, jb_alert_css_default];
__decorateClass([
  n({ type: Object })
], JbAlert.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAlert.prototype, "content", 2);
__decorateClass([
  n()
], JbAlert.prototype, "legend", 2);
__decorateClass([
  n({ type: Boolean })
], JbAlert.prototype, "showLegend", 2);
__decorateClass([
  n()
], JbAlert.prototype, "svgLogo", 2);
__decorateClass([
  n()
], JbAlert.prototype, "title", 2);
JbAlert = __decorateClass([
  customElement("jb-alert")
], JbAlert);

export {
  JbAlert
};
